import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import { useAudiences } from 'app/audiences/application'
import {
  Connection,
  PageHeader,
  PagedTable,
  PagedTableFunctions,
  SearchInput,
} from 'app/common/presentation'
import { AudiencesIcon } from 'app/common/presentation/icons'

import { Status, Table } from 'components'

import { translateStatus } from '.'
import styles from './Audiences.module.scss'

const Audiences = () => {
  const navigate = useNavigate()
  const { t } = useTranslation('audiences')
  const { audiences } = useAudiences()

  const [search, setSearch] = useState('')
  const [filteredAudiences, setFilteredAudiences] = useState(audiences)

  const pagedTableRef = useRef<PagedTableFunctions>(null)

  useEffect(() => {
    const lowerCasedSearch = search.toLowerCase()
    setFilteredAudiences(
      audiences.filter((audience) => {
        if (lowerCasedSearch) {
          const status = t(`status.${audience.status}`)
          return (
            audience.name?.toLocaleLowerCase().includes(lowerCasedSearch) ||
            audience.config.purpose?.toLocaleLowerCase().includes(lowerCasedSearch) ||
            status.toLocaleLowerCase().includes(lowerCasedSearch)
          )
        }

        return true
      }),
    )

    if (search.length && pagedTableRef.current) {
      pagedTableRef.current.setPage(1)
    }
  }, [audiences, search, t])

  return (
    <div className={styles.audiences}>
      <PageHeader
        badge={filteredAudiences.length}
        icon={AudiencesIcon}
        title={t('overview.headline')}
      >
        <div className={styles.toolbar}>
          <SearchInput
            className={styles.search}
            onChange={setSearch}
            placeholder={t('overview.search')}
            value={search}
          />
        </div>
      </PageHeader>
      <PagedTable
        ref={pagedTableRef}
        className={styles.table}
        columns={[
          t('overview.table.name'),
          t('overview.table.connection'),
          t('overview.table.type'),
          t('overview.table.status'),
        ]}
        data={filteredAudiences}
        renderRow={(audience, index) => (
          <Table.Row key={index} onClick={() => navigate(`${audience.id}`)}>
            <Table.Cell>
              <AudiencesIcon />
              {audience.name}
            </Table.Cell>
            <Table.Cell>
              <Connection connection={audience.connection} />
            </Table.Cell>
            <Table.Cell>
              {audience.config.purpose ? t(`type.${audience.config.purpose}`) : '-'}
            </Table.Cell>
            <Table.Cell>
              <Status status={translateStatus(audience.status)}>
                {t(`status.${audience.status}`)}
              </Status>
            </Table.Cell>
          </Table.Row>
        )}
        useSearchParamsPaging
      />
    </div>
  )
}

export default Audiences
